import { render, staticRenderFns } from "./IdentityIntegration.vue?vue&type=template&id=03dfa8fc&scoped=true&"
import script from "./IdentityIntegration.vue?vue&type=script&lang=ts&"
export * from "./IdentityIntegration.vue?vue&type=script&lang=ts&"
import style0 from "./IdentityIntegration.vue?vue&type=style&index=0&id=03dfa8fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dfa8fc",
  null
  
)

export default component.exports